import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 91.86 88.34' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='general_content' data-name='general content'>
        <path
          className='cls-1'
          d='M74.23 0h-6.92v8.51H24.54V0h-6.91v8.51H0v79.83h91.86V8.51H74.23zm12.16 82.87H5.47V32.71h80.92v50.16zm0-68.89v13.27H5.47V14h12.16v5.16h6.91V14h42.78v5.16h6.91V14z'
        />
        <path
          className='cls-1'
          d='M16.13 39.27h7.65v7.65h-7.65zM33.44 39.27h7.65v7.65h-7.65zM50.76 39.27h7.65v7.65h-7.65zM68.07 39.27h7.65v7.65h-7.65zM16.13 54.03h7.65v7.65h-7.65zM33.44 54.03h7.65v7.65h-7.65zM50.76 54.03h7.65v7.65h-7.65zM68.07 54.03h7.65v7.65h-7.65zM16.13 68.79h7.65v7.65h-7.65zM33.44 68.79h7.65v7.65h-7.65zM50.76 68.79h7.65v7.65h-7.65z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CalendarIcon.js